import { useContext, useEffect } from "react";
import axios from "axios";
import { FriendContext } from "../helpers/FriendContext";
import animated_profile_picture_2 from "../assets/animated_profile_picture_2.png";

function FriendsList() {
  const { friends, setFriends } = useContext(FriendContext);

  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/friends/accepted", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log(response.data);
        setFriends(response.data);
      })
      .catch((error) => {
        console.error("Error fetching friends:", error);
      });
  }, []);

  const removeFriend = (friendId) => {
    axios
      .delete(`https://verbalvortex-server.onrender.com/friends/${friendId}`, {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log(response.data);
        alert("Friend removed");
        setFriends((prevFriends) =>
          prevFriends.filter((friend) => friend.id !== friendId)
        );
      })
      .catch((error) => {
        console.error("Error removing friend:", error);
      });
  };

  return (
    <div className="FriendsList">
      <h2 id="FriendsList__title">MY FRIENDS</h2>
      <hr />
      <div id="FriendsList__friends">
        {friends.map((friend) => (
          <div id="FriendsList__friend">
            <div key={friend.id}>
              <img src={animated_profile_picture_2} />
              <div>
                Full name:{" "}
                <p id="FriendsList__FriendFullname">{friend.fullname}</p>
              </div>
              <div>Aka: {friend.username}</div>
              <div>Country: {friend.country}</div>
              <div>Score: {friend.score}</div>
              <button
                id="FriendsList__RemoveFriend"
                onClick={() => removeFriend(friend.id)}
              >
                Remove Friend
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FriendsList;
